import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FieldConfig } from "@biletix/core/models/base/field-config.model";
import { FormGroup } from "@angular/forms";
import { Gender } from "@biletix/core/common/enums/gender.enum";

@Component({
  selector: 'btx-radio-button',
  templateUrl: './btx-radio-button.component.html',
  styleUrls: ['./btx-radio-button.component.scss'],
  standalone: false
})
export class BtxRadioButtonComponent implements OnInit, AfterViewInit {

  field: FieldConfig | any;

  group: FormGroup | any;


  constructor() {
  }

  ngOnInit(): void {
    if (this.field?.type?.toLowerCase() == "gender") {
      this.setGenderOptions();
    }
    this.resetRadioButtonSelection();
  }

  ngAfterViewInit(): void {
    this.resetRadioButtonSelection();
  }

  resetRadioButtonSelection(): void {
    if (this.group && this.field?.name) {
      const control = this.group.get(this.field.name);
      if (control) {
        control.setValue(null, { emitEvent: false });
      }
    }
  }

  setGenderOptions(): void {
    this.field.options = [
      { value: Gender.FEMALE, label: "shared.labels.female" },
      { value: Gender.MALE, label: "shared.labels.male" },
    ];
  }

}


